import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import moment from 'moment';
import { BehaviorSubject, Observable, Subject, from } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';

@Injectable({
  providedIn: 'root'
})

export class FormlyDynamicService {
 
  timeCycleChanges = new Subject<any>();
 
  constructor(
    private apiService: ApiService,
    private filterService: FilterService
  ) {
    
  }

  findSelectedDate(maxDate:any) {
    let dbDate = {
      end : maxDate,
      start: new Date(maxDate)
    }

    let differenceInDays = this.selectedByDefaultNumber(dbDate.end);
    dbDate.start.setDate(dbDate.end.getDate() - differenceInDays);

    return dbDate;
  }
  
  findAllSelectedDate(date:any, flag:boolean) {
    let dbDate = {
      start: flag ? moment(date.start).format("MM-DD-YYYY")  : null,
      end : flag ?  moment(date.end).format("MM-DD-YYYY") : null
    }
    return dbDate;
  }
 
  findAllYearlySelectedDate(date:any, flag:boolean) {
    let dbDate = {
      selectedDate: flag ? moment(date).format("YYYY")  : null,
    }
    return dbDate;
  }
  
  findAllYearlyResetSelectedDate(date:any) {
    let dbDate = {
      selectedDate: date ? moment(date).format("YYYY")  : null,
    }
    return dbDate;
  }

  setFormlyFormValue(tempOption:any, dbDate:any) {
    return {
      [tempOption.fromDateProp] : dbDate.start,
      [tempOption.toDateProp] : dbDate.end
    }
  }

  selectedByDefaultNumber(maxDate:any) {
    let defaultDate: any = new Date("2024-10-01"); 
    let currentDate: any = maxDate; 
    let differenceInTime = currentDate.getTime() - defaultDate.getTime();
    return Math.round(differenceInTime / (1000 * 60 * 60 * 24));
  }

  setBadges(key:any, dbDate:any,option:any) {
    // debugger
    this.filterService.setBadgeValue(
      key,
      dbDate?.start ? moment(dbDate.start).format('MM/DD/YY') : '',
      dbDate?.end ? moment(dbDate.end).format('MM/DD/YY') : '',
      dbDate,
      "formlyDateRangeSelection",
      '',
      "",
      "D",
      option

    )
  }
  
  setYearlyBadges(key:any, dbDate:any,option:any) {
    // debugger
    this.filterService.setBadgeValue(
      key,
      dbDate?.start ? moment(dbDate?.start).format('YYYY') : '',
      dbDate?.end ? moment(dbDate?.end).format('YYYY') : '',
      dbDate,
      "formlyYearlySelection",
      '',
      "",
      'Y',
      option
    )
  }

  getCycleDate(method: any, url: any, parameter: any, model: any, obj:any): Promise<any> {
  
    let request: any = {};

    if(sessionStorage.getItem("brandKeyForFilters")) {
      const brand_key: any = sessionStorage.getItem("brandKeyForFilters");
      const brand = JSON.parse(brand_key);
      request['brand_key'] = brand;
    }

    if(sessionStorage.getItem("tbl_name_suffix_non_frm")) {
      let json:any = sessionStorage.getItem("tbl_name_suffix_non_frm");
      json = JSON.parse(json);
      request['tbl_name_suffix'] = json.tbl_name_suffix;  
    }

    let keys = parameter.split(",");
    for (let k in keys) {
      let keyName = keys[k];
      
      if(model[keyName]) {
        request[keyName] = model[keyName][keyName];
      }
    }

    if(sessionStorage.getItem("tbl_name_suffix")) {
      let json:any = sessionStorage.getItem("tbl_name_suffix");
      json = JSON.parse(json);
      request['tbl_name_suffix'] = json.tbl_name_suffix;  
    }

    Object.assign(request, obj);

    if (!request.brand_key) {
      return Promise.resolve([]);
    }

    return new Promise((resolve, reject) => {
      if (method.toUpperCase() == "POST") {
        this.apiService.post(url, request).subscribe((res) => {
          resolve(res);
        });
      } else {
        this.apiService.get(url).subscribe((res) => { resolve(res) });
      }
    });
  }
}
